import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const initialForm = {
  systemCode: "ERP",
  directionCode: "IN",
  eventType: "ORDER_SYNC",
  externalKey: "",
  relatedEntityType: "ORDER",
  relatedEntityId: "",
  eventStatus: "PENDING",
  errorMessage: "",
};

export const OssIntegrationEventDialog = ({ open, loading, onClose, onSubmit }) => {
  const [form, setForm] = useState(initialForm);
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const submit = () =>
    onSubmit({
      ...form,
      relatedEntityId: form.relatedEntityId || undefined,
      errorMessage: form.errorMessage || undefined,
      requestPayload: { source: "manual-monitor" },
    }).then(() => setForm(initialForm));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pr: 6, fontWeight: 900 }}>
        연계 이벤트 등록
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 10 }}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.4}>
          <Grid container spacing={1.2}>
            <Grid item xs={12} md={3}>
              <TextField select fullWidth size="small" label="시스템" value={form.systemCode} onChange={(e) => update("systemCode", e.target.value)}>
                <MenuItem value="ERP">ERP</MenuItem>
                <MenuItem value="MES">MES</MenuItem>
                <MenuItem value="APS">APS</MenuItem>
                <MenuItem value="OTHER">기타</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField select fullWidth size="small" label="방향" value={form.directionCode} onChange={(e) => update("directionCode", e.target.value)}>
                <MenuItem value="IN">수신</MenuItem>
                <MenuItem value="OUT">송신</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField select fullWidth size="small" label="상태" value={form.eventStatus} onChange={(e) => update("eventStatus", e.target.value)}>
                <MenuItem value="PENDING">대기</MenuItem>
                <MenuItem value="PROCESSING">처리 중</MenuItem>
                <MenuItem value="SUCCESS">성공</MenuItem>
                <MenuItem value="FAILED">실패</MenuItem>
                <MenuItem value="RETRY">재시도</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField select fullWidth size="small" label="관련 대상" value={form.relatedEntityType} onChange={(e) => update("relatedEntityType", e.target.value)}>
                <MenuItem value="ORDER">주문</MenuItem>
                <MenuItem value="ORDER_LINE">주문 품목</MenuItem>
                <MenuItem value="SCHEDULE">일정</MenuItem>
                <MenuItem value="">없음</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid container spacing={1.2}>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="이벤트 유형" value={form.eventType} onChange={(e) => update("eventType", e.target.value)} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="외부 키" value={form.externalKey} onChange={(e) => update("externalKey", e.target.value)} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" type="number" label="관련 ID" value={form.relatedEntityId} onChange={(e) => update("relatedEntityId", e.target.value)} />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="오류 메시지"
            value={form.errorMessage}
            onChange={(e) => update("errorMessage", e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button variant="contained" disabled={loading || !form.eventType} onClick={submit}>
          등록
        </Button>
      </DialogActions>
    </Dialog>
  );
};
